import './breadcrumb-style.scss'

import { Link } from 'gatsby'
import _ from 'lodash'
import React from 'react'

import { ReactComponent as ChevronIcon } from '@/assets/icons/crypto_general_icons_chevron-down_clean.svg'

const Breadcrumb = ({
  i18n,
  category,
  // subcategory,
  t,
}) => {
  const description = _.toLower(_.get(category, 'description'))
  const url = _.toLower(_.get(category, 'url'))
  const breakcrumb = [
    {
      link: '/trending',
      name: 'All Articles',
      hasChevron: !_.isEmpty(_.get(category, 'description')),
    },
  ]
  if (category) {
    breakcrumb.push({
      link: i18n.language === 'en' ? `/${url}` : `/${i18n.language}/${url}`,
      name: t(`breadcrumb.${description}`),
      hasChevron: false,
    })
  }
  return (
    <div className="breadcrumb">
      {_.map(breakcrumb, (crumb, idx) => (
        <Link
          key={idx}
          to={crumb.link}
          state={!_.isEmpty(crumb.state) ? crumb.state : null}
        >
          <p>{crumb.name}</p>
          {crumb.hasChevron && <ChevronIcon className="icon-chevron" />}
        </Link>
      ))}
    </div>
  )
}

export default Breadcrumb
